module.exports = __webpack_public_path__ + "img/starpoweer.dfb05758.svg";